module.exports = __webpack_public_path__ + "img/file-earmark-person-fill.357a539b.svg";